{
  "title": "Entrar al dojo 🥷",
  "startLabelingButton": "Comencemos a etiquetar 🚀"
}
